import { render } from "./ViscosityData.vue?vue&type=template&id=8beaee44"
import script from "./ViscosityData.vue?vue&type=script&lang=js"
export * from "./ViscosityData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__